<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('app.international.internationalCard')" name="first">
        <Card></Card>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.international.esimCard')" name="second" v-if="checkPermi(['international:esim:list'])">
        <Esim></Esim>
      </el-tab-pane>
      <el-tab-pane :label="$t('app.international.vsimCard')" name="third" v-if="checkPermi(['international:vsim:list'])">
        <Vsim></Vsim>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Card from "./Card.vue";
import Esim from "./Esim.vue";
import Vsim from "./Vsim.vue";
export default {
  name: "internationalCards",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    Card,
    Esim,
    Vsim
  },
  created() {
  },
};
</script>